module.exports = __webpack_public_path__ + "img/valencia-logo-icon.df95802f.png";